import React from 'react';
import quotesStyles from '../../../styles/quotes.module.css';

export default function Checkbox(props) {
  return (
    <button
      type="button"
      disabled={!!props.disabled}
      className={`${quotesStyles['plan-visit-checkbox-container']} ${props.isSelected ? quotesStyles['plan-visit-checkbox-selected'] : quotesStyles['plan-visit-checkbox']}`}
      onClick={() => props.handleChange(props.isSelected, props.value)}
    >
      <span style={{ display: 'inline-block' }}>{props.label}</span>
    </button>
  );
}


